import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
// oxlint-disable-next-line no-restricted-imports
import { createEntryPoint } from '@atlassian/react-entrypoint';

type LegacyPageEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const legacyPageEntrypoint: EntryPoint<LegacyPageEntrypointComponent, {}> = createEntryPoint(
	{
		root: JSResourceForUserVisible<LegacyPageEntrypointComponent>(
			/* webpackChunkName: "async-legacy-page-entrypoint" */ './index.tsx',
		),
		getPreloadProps: () => ({}),
	},
);
